import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { DateCurrencyFromatter } from '@vfgroup-oneplatform/foundation/Utils';

import styles from './DeviceUpgradeHeader.Styles';

const { currencyTransformer } = DateCurrencyFromatter.dateCurrencyFromatter;
const DeviceUpgradeHeader = ({ phoneName, upfront, recurring }) => {
  return (
    <>
      <VFText i18nKey={phoneName} style={styles.phoneTitle} />
      <View style={styles.subheader}>
        <VFText i18nKey={currencyTransformer(upfront, 0)} style={styles.upfrontValue} />
        <VFText i18nKey={'device_upgrade_header_upfront_price_text'} style={styles.upfrontTitle} />
        <VFText i18nKey={currencyTransformer(recurring, 0)} style={styles.monthlyValue} />
        <VFText
          i18nKey={'device_upgrade_header_recuring_price_text_monthly'}
          style={styles.monthlyTitle}
        />
      </View>
    </>
  );
};

DeviceUpgradeHeader.propTypes = {
  phoneName: PropTypes.string,
  upfront: PropTypes.string,
  recurring: PropTypes.string,
};

export default DeviceUpgradeHeader;
